import { cn } from "@acme/utils";
import * as React from "react";
import {
  Button as BaseButton,
  buttonVariants,
} from "@/components/base-ui/button";

// Optogrid override: the base shadcn `ghost` and `outline` variants use
// `hover:bg-accent`, which in the redesign tokens is the bright promoted orange
// (`--accent` = #fe9400). Per `docs/design_handoff_app/README.md`, accent-orange
// is reserved for focus rings, table body-row hover, status pills, etc. — not
// generic button hover. Route those hovers to a neutral surface instead.
const NEUTRAL_HOVER_OVERRIDE =
  "hover:bg-secondary hover:text-foreground dark:hover:bg-secondary/50";

type ButtonProps = React.ComponentProps<typeof BaseButton>;

function Button({ className, variant, ...props }: ButtonProps) {
  return (
    <BaseButton
      variant={variant}
      className={cn(
        (variant === "ghost" || variant === "outline") &&
          NEUTRAL_HOVER_OVERRIDE,
        className,
      )}
      {...props}
    />
  );
}

export { Button, buttonVariants };
